import { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useSelector } from "react-redux";
import MergersAcquisitionDetails from "./MergersAcquisitionDetails";
import { TabContent, TabPane } from "reactstrap";
import { scrollToTop } from "../../../../../CloudStorage/CommonFunction";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import YourPost from "../../../../Common/Label/YourPost";
import TranslatedText from "../../../../Common/TranslatedText";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function AllMergersAcquisition({ theactiveTab }) {
  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const { state, setPageNumber } = useAllFilterBaseContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [bxpData, setbxpData] = useState("");
  const [activeTab, setActiveTab] = useState("BXPDetails");

  const closeModal = () => {
    setModalOpen(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-100%",
  };
  useEffect(() => {
    scrollToTop();
  }, [activeTab]);

  const getallmerger = useSelector(
    ({ mergers: { getfilterdmergers } }) => getfilterdmergers
  );
  const getmergerslist = getallmerger?.response || [];

  const handleImageError = (e) => {
    e.target.src = `${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-1.png`;
  };

  return (
    <div className="col-lg-9 col-md-8 filter-right">
      <h2>All <TranslatedText i18nKey="MAS1" /> results</h2>
      <>
        {Array.isArray(getmergerslist) && getmergerslist.length > 0 ? (
          <div className="row packaged-row merger-packaged">
            {Array.isArray(getmergerslist) &&
              getmergerslist?.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-6" key={index}>
                  <div className="d-flex post-sold">
                    <YourPost item={item} />
                  </div>
                  <div
                    className="packaged-img"
                  // onClick={() => navigate(`/${lan}/productdetails/${item?.id}`)}
                  >
                    <ProfileImageWithFallback url={item?.logo} style={{ objectFit: 'contain', width:'200px', borderRadius: 0 }} />
                    {/* <img
                      src={item?.logo}
                      alt=""
                      className="w-100"
                      onError={handleImageError}
                    /> */}
                    <h3>{item?.company_name}</h3>
                    <h6>{item?.industry_title}</h6>
                    <p>{item?.website_link}</p>
                    <p>
                      {" "}
                      {item?.address} {item?.city} - {item?.pincode}
                    </p>
                    <button
                      className="buttons border-button"
                      onClick={() => {
                        setModalOpen(true);
                        setbxpData(item);
                      }}
                    >
                      {" "}
                      View more
                    </button>
                  </div>
                </div>
              ))}

          </div>
        ) : (
          <PostNotFound title={"Merger & Acquisition Services (MAS) Not Found..."} />
        )}
        {getallmerger && <CommonPagination
          totalitemcounts={
            theactiveTab == "allpost"
              ? getallmerger?.count?.count
              : theactiveTab == "recentview"
                ? getallmerger?.count?.viewed_count
                : theactiveTab == "savepost"
                  ? getallmerger?.count?.wishlist_count
                  : getallmerger?.count?.count
          }
          size={15}
          pageNumber={state?.pageNumber}
          setPageNumber={setPageNumber}
        />}
      </>
      {
        modalOpen &&
        <div
          isOpen={modalOpen}
          keyboard={false}
          // className="add-education-modal add-bxp-modal"
          className={`add-education-modal add-bxp-modal add-overlay-modal-width ${modalOpen ? "active" : ""
            }`}
          style={modalStyle}

      >
        <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
          <div className="modal-width">
            <div className="modal-head">
              <h3> Information</h3>
              <button onClick={closeModal} className="btn close-modal-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                  alt="Close"
                />
              </button>
            </div>

            <div className="tab-bxp">
              <TabContent activeTab={activeTab}>
                <TabPane tabId="BXPDetails">
                  <MergersAcquisitionDetails
                    bxpData={bxpData}
                    setActiveTab={setActiveTab}
                    setModalOpen={setModalOpen}
                    needtohitapi={false}
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      }
    </div>
  );
}
